import React, { useState, useEffect, useMemo } from "react";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

const metodosPago = [
  { label: "Efectivo", value: "efectivo" },
  { label: "Transferencia", value: "transferencia" },
  { label: "Tarjeta", value: "tarjeta" },
];

const PagosManual = () => {
  const axiosPrivate = useAxiosPrivate();

  const [alumnos, setAlumnos] = useState([]);
  const [alumno, setAlumno] = useState(null);
  const [cargos, setCargos] = useState([]);
  const [selected, setSelected] = useState([]);
  const [metodo, setMetodo] = useState("efectivo");

  // 🔹 cargar alumnos
  useEffect(() => {
    axiosPrivate.get("CEUM/alumnos/listado")
      .then(res => setAlumnos(res.data))
      .catch(console.error);
  }, []);

  // 🔹 buscar cargos
  const buscar = async (matricula) => {
    const res = await axiosPrivate.get(`CEUM/cargos/${matricula}`);
    const data = res.data.map(r => ({
      ...r,
      pagar: 0
    }));
    setCargos(data);
    setSelected([]);
  };

  // 🔹 cambio de monto
  const onChangeMonto = (rowData, value) => {
    const updated = cargos.map(r =>
      r.id === rowData.id
        ? { ...r, pagar: Number(value) || 0 }
        : r
    );
    setCargos(updated);

    // 🔥 sincronizar también selección
    const updatedSelected = selected.map(s =>
      s.id === rowData.id
        ? { ...s, pagar: Number(value) || 0 }
        : s
    );
    setSelected(updatedSelected);
  };

  // 🔹 total dinámico
  const total = useMemo(() => {
    return selected.reduce((acc, r) => acc + Number(r.pagar || 0), 0);
  }, [selected]);

  // 🔹 selección
  const onSelectionChange = (e) => {
    const selectedRows = e.value.map(r => ({
      ...r,
      pagar: r.pagar && r.pagar > 0 ? r.pagar : r.saldo
    }));

    const updated = cargos.map(r => {
      const found = selectedRows.find(s => s.id === r.id);
      return found ? { ...r, pagar: found.pagar } : r;
    });

    setCargos(updated);
    setSelected(selectedRows);
  };

  // 🔹 registrar pago
  const registrarPago = async () => {
    if (selected.length === 0) {
      alert("Selecciona al menos un cargo");
      return;
    }
    console.log(selected);
//return;
    await axiosPrivate.post("CEUM/pagos", {
      matricula: alumno?.Matricula,
      metodo_pago: metodo,
      items: selected.map(r => ({
        id_cargo: r.id,
        monto: r.pagar || r.saldo
      }))
    });

    buscar(alumno.Matricula);
  };

  const money = (v) => `$ ${Number(v || 0).toFixed(2)}`;

  return (
    <>
      {/* 🔹 selector alumno */}
      <div className="flex gap-2 mb-3">
        <Dropdown
          value={alumno}
          options={alumnos}
          onChange={(e) => {
            setAlumno(e.value);
            if (e.value) buscar(e.value.Matricula);
            else setCargos([]);
          }}
          optionLabel="nombre_completo"
          placeholder="Selecciona alumno"
          filter
          showClear
        />
      </div>

      {/* 🔹 método pago */}
      <div className="mb-3" style={{ maxWidth: "250px" }}>
        <label>Método de pago</label>
        <Dropdown
          value={metodo}
          options={metodosPago}
          onChange={(e) => setMetodo(e.value)}
        />
      </div>

      {/* 🔹 tabla */}
      <DataTable
        value={cargos}
        selection={selected}
        onSelectionChange={onSelectionChange}
        dataKey="id"
        paginator
        rows={10}
        className="p-datatable-sm"
      >
        <Column selectionMode="multiple" style={{ width: "3rem" }} />
        <Column field="concepto" header="Concepto" />
        <Column field="periodo" header="Periodo" />
        <Column field="fecha_vencimiento" header="Vencimiento" />
        <Column header="Saldo" body={(row) => money(row.saldo)} />

        <Column
          header="Pagar"
          body={(row) => (
            <InputNumber
              value={row.pagar}
              onValueChange={(e) => onChangeMonto(row, e.value)}
              mode="currency"
              currency="MXN"
              min={0}
              max={row.saldo}
            />
          )}
        />

        <Column field="estatus" header="Estatus" />
      </DataTable>

      {/* 🔹 total */}
      <div className="flex justify-content-end mt-3">
        <h3>Total: {money(total)}</h3>
      </div>

      {/* 🔹 botones */}
      <div className="flex justify-content-end mt-3 gap-2">
        <Button
          label="Cancelar"
          className="p-button-text"
          onClick={() => setSelected([])}
        />
        <Button
          label="Registrar Pago"
          icon="pi pi-check"
          onClick={registrarPago}
        />
      </div>
    </>
  );
};

export default PagosManual;